exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.layout-content[data-v-31894663]{padding-top:72px\n}\n.Home__PageTeller[data-v-31894663]{position:fixed;width:100%;z-index:2\n}\n.Home__PageTeller .md-title[data-v-31894663]{text-transform:capitalize\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-31894663","scoped":true,"sourceMap":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/spa/Home.vue
// module id = 100
// module chunks = 0